import { createAction, props } from '@ngrx/store';

export const billingPortal = createAction(
  '[Billing Portal] URL',
  props<{ userId: number }>()
);

export const billingPortalSuccess = createAction(
  '[Billing Portal] Login Success',
  props<{ data: any }>()
);

export const billingPortalFailure = createAction(
  '[Billing Portal] Login Failure',
  props<{ error: any }>()
);

export const loadBillings = createAction(
  '[Billing] Load Billings',
  props<{ userId: number, page: number }>()
);

export const loadBillingsSuccess = createAction(
  '[Billing] Load Billings Success',
  props<{ data: any[] }>()
);

export const loadBillingsFailure = createAction(
  '[Billing] Load Billings Failure',
  props<{ error: any }>()
);

export const loadInvoice = createAction(
  '[Billing] Load Invoice',
  props<{ invoiceId: number }>()
);

export const loadInvoiceSuccess = createAction(
  '[Billing] Load Invoice Success',
  props<{ data: any }>()
);

export const loadInvoiceFailure = createAction(
  '[Billing] Load Invoice Failure',
  props<{ error: any }>()
);

export const clearInvoice = createAction(
  '[Billing] Clear Invoice'
);
